module.exports = __webpack_public_path__ + "static/media/instagram.e2826158.svg";